import { generateTypes } from '../utils/HttpReducerHelper';

const createEntityProfile = generateTypes('ENTITY_PROFILE', 'CREATE_PROFILE');
const entityProfile = generateTypes('ENTITY_PROFILE', 'PROFILE');
const updateProfileSection = generateTypes('ENTITY_PROFILE', 'UPDATE_PROFILE_SECTION');

export { createEntityProfile, entityProfile, updateProfileSection };
